
import React, { useEffect, useState } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { motion, AnimatePresence } from 'framer-motion';

interface LoadingScreenProps {
  isLoading: boolean;
  minDuration?: number;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  isLoading, 
  minDuration = 500 
}) => {
  const [shouldShow, setShouldShow] = useState(false);
  const [startTime, setStartTime] = useState<number | null>(null);

  useEffect(() => {
    if (isLoading) {
      setShouldShow(true);
      setStartTime(Date.now());
      // Prevenir scroll durante o loading
      document.body.style.overflow = 'hidden';
    } else if (startTime) {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, minDuration - elapsed);
      
      setTimeout(() => {
        setShouldShow(false);
        document.body.style.overflow = 'unset';
      }, remaining);
    }

    return () => {
      if (!isLoading) {
        document.body.style.overflow = 'unset';
      }
    };
  }, [isLoading, startTime, minDuration]);

  return (
    <AnimatePresence>
      {shouldShow && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[9999] bg-background flex items-center justify-center"
          style={{ 
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999
          }}
        >
          <div className="flex flex-col items-center justify-center">
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64"
            >
              <DotLottieReact
                src="https://lottie.host/0e77b563-83e6-460a-b37d-32305683eb5f/9otbP5U89G.lottie"
                loop
                autoplay
                className="w-full h-full"
              />
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="mt-4 text-center"
            >
              <h3 className="text-lg font-semibold text-foreground mb-2">
                Carregando...
              </h3>
              <p className="text-sm text-muted-foreground">
                Preparando sua experiência
              </p>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
